import * as types from './types';

const fetchLeadsSeeker = id => ({ type: types.FETCH_SEEKER_LEADS, payload: id });
const fetchLeadsSeekerSucceeded = data => ({ type: types.FETCH_SEEKER_LEADS_SUCCEEDED, payload: data });
const fetchLeadsSeekerFailed = error => ({ type: types.FETCH_SEEKER_LEADS_FAILED, payload: error });
const setLeadsOrderSeekers = data => ({ type: types.SET_SEEKER_LEADS_ORDER, payload: data });
const setLeadsOfSetSeeker = data => ({ type: types.SET_SEEKER_LEADS_OFSET, payload: data });
const fetchLeadsSeekerMobile = id => ({ type: types.FETCH_SEEKER_LEADS_MOBILE, payload: id });
const fetchLeadsSeekerSucceededMobile = data => ({ type: types.FETCH_SEEKER_LEADS_SUCCEEDED_MOBILE, payload: data });
const fetchLeadsSeekerSucceededMobileSorted = data => ({
  type: types.FETCH_SEEKER_LEADS_SUCCEEDED_MOBILE_SORTED,
  payload: data
});

const fetchLeadsSeekerFailedMobile = error => ({ type: types.FETCH_SEEKER_LEADS_FAILED_MOBILE, payload: error });
const fetchLeadsMobileSucceededEvent = data => ({
  type: types.FETCH_SEEKER_MOBILE_SUCCEEDED_UPDATE_EVENT,
  payload: data
});
export {
  fetchLeadsSeeker,
  fetchLeadsSeekerSucceeded,
  fetchLeadsSeekerFailed,
  setLeadsOrderSeekers,
  setLeadsOfSetSeeker,
  fetchLeadsSeekerMobile,
  fetchLeadsSeekerSucceededMobile,
  fetchLeadsSeekerFailedMobile,
  fetchLeadsMobileSucceededEvent,
  fetchLeadsSeekerSucceededMobileSorted
};
